import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { CHANGE_PASSWORD, GET_USER_PROFILE, UPDATE_ADMIN, UPLOAD_PROFILE_IMAGE, GET_AUTH_URL, VERIFY_OTP, AUTH_OTP_DISABLE } from 'grapqhl';
import {
    Admin,
    AdminResponse,
    ChangePasswordDTO,
    ChangePasswordResponse,
    GetPreSignedUrlResponse,
    OTPAuthUrlResponse,
    PreSignedUrlResponse,
    UserProfileResponse,
    VerifyOTPAuthUrlResponse,
    uploadProfileImageDTO
} from '../../../types/profile';

export const useGQL = () => {
    const ADMIN_CHANGE_PASSWORD = () => useMutation<ChangePasswordResponse,{body:ChangePasswordDTO} >(CHANGE_PASSWORD);
    const GET_ADMIN_PROFILE = () => useQuery<UserProfileResponse>(GET_USER_PROFILE);
    const UPDATE_ADMIN_PROFILE = () => useMutation<AdminResponse, {body: Partial<Admin> }>(UPDATE_ADMIN);
    const IMAGE_UPLOAD = () => useLazyQuery<GetPreSignedUrlResponse, { body }>(UPLOAD_PROFILE_IMAGE);
    const GET_OTP_AUTH_URL = (skipCondition) => useQuery<OTPAuthUrlResponse>(GET_AUTH_URL, { skip: skipCondition });
    const VERIFY_AUTH_OTP = () => useMutation<VerifyOTPAuthUrlResponse, { token: string }>(VERIFY_OTP);
    const DISABLE_AUTH_OTP = () => useMutation<any, { token: string }>(AUTH_OTP_DISABLE);


    return {
        ADMIN_CHANGE_PASSWORD,
        GET_ADMIN_PROFILE,
        UPDATE_ADMIN_PROFILE,
        IMAGE_UPLOAD,
        GET_OTP_AUTH_URL,
        VERIFY_AUTH_OTP,
        DISABLE_AUTH_OTP,
    };
};
